/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { Box } from "@mui/material";

export const CustomFields = forwardRef((props: any, ref) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const selectItem = (index: number) => {
    const item = props.items[index];

    if (item) {
      props.command({ id: item.name, label: item.description });
    }
  };

  const upHandler = () => {
    setSelectedIndex(
      (selectedIndex + props.items.length - 1) % props.items.length
    );
  };

  const downHandler = () => {
    setSelectedIndex((selectedIndex + 1) % props.items.length);
  };

  const enterHandler = () => {
    selectItem(selectedIndex);
  };

  useEffect(() => setSelectedIndex(0), [props.items]);

  useImperativeHandle(ref, () => ({
    onKeyDown: ({ event }: { event: any }) => {
      if (event.key === "ArrowUp") {
        upHandler();
        window.setTimeout(() => {
          document.querySelector('.is-selected')?.scrollIntoView({block: 'nearest'});
        }, 50);
        return true;
      }

      if (event.key === "ArrowDown") {
        downHandler();
        window.setTimeout(() => {
          document.querySelector('.is-selected')?.scrollIntoView({block: 'nearest'});
        }, 50);
        return true;
      }

      if (event.key === "Enter") {
        enterHandler();
        return true;
      }

      return false;
    },
  }));

  return (
    <Box
      className="dropdown-menu"
      sx={{
        backgroundColor: 'background.paper',
        border: '1px solid',
        borderColor: 'grey.400',
        borderRadius: 3,
        display: 'flex',
        flexDirection: 'column',
        gap: '0.1rem',
        scrollBehavior: 'smooth',
        padding: '0.4rem',
        position: 'relative',
        '& button': {
          alignItems: 'center',
          backgroundColor: 'transparent',
          display: 'flex',
          padding: '5px',
          cursor: 'pointer',
          borderRadius: 1,
          gap: '0.25rem',
          border: 'none',
          textAlign: 'left',
          width: '100%',
          '&:hover, &:hover.is-selected, &.is-selected': {
            backgroundColor: 'grey.300',
          },
        },
      }}
    >
      {props.items.length ? (
        props.items.map((item: any, index: number) => (
          <button
            className={index === selectedIndex ? "is-selected" : ""}
            key={index}
            onClick={() => selectItem(index)}
          >
            {item.description}
          </button>
        ))
      ) : <div></div>}
    </Box>
  );
});
